
(function() {
  /*$('.article-masonry .grid').masonry({
    gutter: 10,
    itemSelector: '.grid-item',
    percentPosition: true
  });*/
  if (typeof(Masonry) !== 'undefined') {
    //new Masonry('.page-masonry .grid', {itemSelector: '.grid-item', columnWidth: 0});
    $(window).on( "load", () => {
      console.log('MASONRY')
      new Masonry('.page-masonry .grid', {itemSelector: '.grid-item', columnWidth: 0});
    });
  }

  var masonryRoot = $('.article-masonry, .page-masonry');
  var modal = $('.modal');
  var modalFade = $('.modal-fade');
  var images = masonryRoot.find('.grid .grid-item');
  var thumbs = modal.find('.modal-thms .img-thm');
  var moreImagesButton = masonryRoot.find('.photos-button');
  var currentImage = modal.find('.image.current'), nextImage = modal.find('.image.next');
  var currentIndex = 0;
  var animationInProgress = false;

  function switchImage(direction) {
    thumbs.removeClass('active');
    $(thumbs[currentIndex]).addClass('active');

    animationInProgress = true;
    var src = $(images[currentIndex]).data('img');
    nextImage.css({ backgroundImage: 'url("' + src + '")' }).css({ opacity: 0.0001, display: 'block', marginLeft: 400 * direction, marginRight: -400 * direction });
    // animate
    nextImage.animate({ opacity: 1, marginLeft: 0, marginRight: 0 }, 500);
    var tmp = currentImage;
    currentImage.animate({ opacity: 0, marginLeft: -400 * direction, marginRight: 400 * direction }, 500, function() {
      tmp.hide();
      animationInProgress = false;
    });
    // swap next and current images
    var t = nextImage;
    nextImage = currentImage;
    currentImage = t;
  }

  function switchToNextImage() {
    if (animationInProgress)
      return;
    currentIndex++;
    if (currentIndex >= images.length)
      currentIndex = 0;

    switchImage(1);
  }

  function switchToPrevImage() {
    if (animationInProgress)
      return;
    currentIndex--;
    if (currentIndex < 0)
      currentIndex = images.length - 1;

    switchImage(-1);
  }

  function switchToClosestImage(e) {
    if (e.screenX < $(window).width() / 2)
      switchToPrevImage();
    else
      switchToNextImage();
  }

  function showModal() {
    thumbs.removeClass('active');
    $(thumbs[currentIndex]).addClass('active');

    currentImage.stop();
    nextImage.stop();
    var src = $(images[currentIndex]).data('img');
    currentImage.css({ backgroundImage: 'url("' + src + '")', margin: 0, opacity: 1 }).show();
    nextImage.hide();
    modal.fadeIn(500);
    modalFade.fadeIn(500);
  }

  function hideModal() {
    modal.fadeOut(200);
    modalFade.fadeOut(200);
  }

  modal.find('.arrow.left').click(switchToPrevImage);
  modal.find('.arrow.right').click(switchToNextImage);
  currentImage.click(switchToClosestImage);
  nextImage.click(switchToClosestImage);
  modal.find('.close').click(hideModal);
  modal.click(function(e) {
    if ($(e.target).hasClass('modal'))
      hideModal();
  });
  images.click(function() {
    currentIndex = images.index(this);
    showModal();
  });
  moreImagesButton.click(function(e) {
    currentIndex = 8;
    showModal();
    return false;
  });
  thumbs.click(function() {
    if (animationInProgress)
      return;
    var newIndex = thumbs.index(this);
    if (newIndex !== currentIndex) {
      var direction = Math.sign(newIndex - currentIndex);
      currentIndex = newIndex;
      switchImage(direction);
    }
    return false;
  });
})();
